import {GoogleMeetIcon} from 'shells/icon/svg/google-meet-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MicrosoftTeamsIcon} from 'shells/icon/svg/microsoft-teams-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ZoomIcon} from 'shells/icon/svg/zoom-icon';

import {GoogleMeetModalContent} from './google-meet-modal-content';
import {MicrosoftTeamsModalContent} from './microsoft-teams-modal-content';
import {ZoomModalContent} from './zoom-modal-content';

export const MODAL_CONTENT_MAP = {
    ZOOM: ZoomModalContent,
    MEET: GoogleMeetModalContent,
    TEAMS: MicrosoftTeamsModalContent,
} as const;

export const ILLUSTRATION_MAP = {
    ZOOM: ZoomIcon,
    MEET: GoogleMeetIcon,
    TEAMS: MicrosoftTeamsIcon,
} as const;

// TODO update
export const WINDOW_SIZE_MAP = {
    ZOOM: {
        width: 600,
        height: 850,
    },
    MEET: {
        width: 600,
        height: 850,
    },
    TEAMS: {
        width: 600,
        height: 850,
    },
} as const;
